//  Version : 0.0.1
//  Author : AGALAYA
// LastEdit : KARTHEESWARAN
// LastAdd  : API URLS CHANGED TO CAMEL CASE
// MODFIED DATE:08-08-2025
import { makeApiCall } from '../_common/api.utils';
import { API_URL } from '../const';
/** ***************** GET PROFILE DETAILS START *********************** */
export const profileDetailsGet = (listData: any) => {
	const data = {
		FetchProfileDetailsToken: listData,
	};
	const url = `${API_URL}fetchProfileDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET PROFILE DETAILS END *********************** */

export const profileDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateProfileToken: updateData,
	};
	const url = `${API_URL}updateProfileDetails`;
	return makeApiCall(url, data);
};
export const passwordUpdate = (updatPasswordData: any) => {
	const data = {
		UpdateUserPasswordToken: updatPasswordData,
	};
	const url = `${API_URL}updateUserPassword`;
	return makeApiCall(url, data);
};
/** ***************** GENERATE SECRETE AUTHKEY START *********************** */
export const secreteAuthKeyGenerate = (updatData: any) => {
	const data = {
		GenerateSecreteAuthToken: updatData,
	};
	const url = `${API_URL}generateSecreteAuthKey`;
	return makeApiCall(url, data);
};
/** ***************** GENERATE SECRETE AUTHKEY END *********************** */

/** ***************** UPDATE IMAGE START *********************** */
export const imageUpdate = (updatImageData: any) => {
	const data = {
		ProfileImageUpdateToken: updatImageData,
	};
	const url = `${API_URL}profileImageUpdate`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE IMAGE START *********************** */
